module.exports = __webpack_public_path__ + "img/18_14.18b188ab.png";